export const LongArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="211"
      height="8"
      viewBox="0 0 211 8"
      fill="none"
    >
      <path
        d="M210.354 4.35354C210.549 4.15828 210.549 3.8417 210.354 3.64644L207.172 0.464457C206.976 0.269195 206.66 0.269195 206.464 0.464457C206.269 0.659719 206.269 0.976302 206.464 1.17156L209.293 3.99999L206.464 6.82842C206.269 7.02368 206.269 7.34026 206.464 7.53552C206.66 7.73079 206.976 7.73079 207.172 7.53552L210.354 4.35354ZM0 4L2.18557e-08 4.5L210 4.49999L210 3.99999L210 3.49999L-2.18557e-08 3.5L0 4Z"
        fill="#BFBFBF"
      />
    </svg>
  );
};
